<template>
  <div class="preview__wrapper">
    <h3>Preview</h3>
    <div
      class="test_model"
      :style="{
        color: textColor,
        backgroundColor,
        borderStyle,
        borderColor,
        borderWidth: `${borderWidth}px`,
        borderRadius: `${borderRadius}px`
      }"
    >
      <span :class="[isSectionVisible ? 'title__template' : 'hidden__section']">
        <font-awesome-icon
          v-if="!isSectionVisible"
          class="text-warning mr-1"
          :icon="['fas', 'eye-slash']"
        />
        {{ sectionName }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionModel',
  props: [
    'sectionName',
    'backgroundColor',
    'textColor',
    'borderRadius',
    'borderWidth',
    'borderStyle',
    'borderColor',
    'isSectionVisible',
  ],
  data() {
    return {
      titleTemplate: '',
    };
  },
};
</script>

<style scoped lang="scss">

.preview__wrapper {
  margin-top: 20px;

}

.test_model {
  padding: 20px;
  box-shadow: 0 0 10px #ccc;
  width: 60%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.hidden__section {
  font-weight: 300;
  color: #ccc;
  font-style: italic;
}
</style>